import { withStyles } from '@material-ui/core';
import { useState } from 'react';
import CustomTextField from '../../../../Dispatch/RouteExecution/DriverPopUp/common/CustomTextField';
import styles from './styles';
import Action from '../../common/components/Action';
import { getFieldError, getErrorInfo } from '../../utils';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import DOWDelWindow from '../../common/components/DOWDelWindow';
import { getDeliveryDays } from '../../utils';

const DOWEditForm = (props) => {
  const {
    location,
    onLocationUpdate,
    onCancelEdit,
    classes,
    isNewLocation = false,
    selectPolygonOnMap,
    isSelectedOnMap,
    isLocationNameAlreadyExist
  } = props;
  const [locationName, setLocationName] = useState(location.locationName);
  const [deliveryDays, setDeliveryDays] = useState(getDeliveryDays(location.dowDelWindow));
  const [errors, setErrors] = useState({});

  const handleLocationNameChange = (value) => {
    const isMatchedLocation = isLocationNameAlreadyExist({ locationName: value, isNewLocation });
    setLocationName(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      locationName: getFieldError({ fieldName: 'locationName', value, isMatchedLocation })
    }));
  };

  const onDeliveryDaysChange = (deliveryDays) => {
    setDeliveryDays(deliveryDays);
  };

  const handleLocationSubmit = () => {
    const isMatchedLocation = isLocationNameAlreadyExist({ locationName, isNewLocation });
    const errorInfo = getErrorInfo({ locationName }, isMatchedLocation);
    const error = Object.values(errorInfo).filter(Boolean).length;

    if (!error) {
      const editedLocation = {
        ...location,
        dowDelWindow: deliveryDays,
        locationName
      };
      onLocationUpdate(editedLocation);
    } else {
      setErrors(errorInfo);
    }
  };

  return (
    <div
      className={`${classes.container} ${isSelectedOnMap ? classes.highlightedCard : ''}`}
      onClick={() => selectPolygonOnMap([location.locationMappingId])}>
      <CustomTextField
        id="locationName"
        label="Location Name"
        handleChange={handleLocationNameChange}
        value={locationName}
        className={classes.locationName}
        error={errors.locationName}
      />
      <DOWDelWindow deliveryDays={deliveryDays} onDeliveryDaysChange={onDeliveryDaysChange} />
      <Action
        onClose={onCancelEdit}
        locationMappingId={location.locationMappingId}
        onConfirm={handleLocationSubmit}
        isNewLocation={isNewLocation}
        locationUpdateInProgress={false}
        submitButtonLabel={isNewLocation ? 'Add Location' : 'Update Location'}
      />
    </div>
  );
};

export default compose(withStyles(styles), withSnackbar)(DOWEditForm);
